import anglia from './assets/home-images/image1.png'
import britishCouncil from './assets/home-images/image2.png'
import fdp from './assets/home-images/image3.png'
import mcast from './assets/home-images/image4.png'
import manipalUniversity from './assets/home-images/image5.png'
import omnix from './assets/home-images/image6.png'
import bolton from './assets/home-images/image7.png'
import vscc from './assets/home-images/image8.png'


export const universityData = [
  {
    id: '1',
    universityName: 'MCAST',
    backTile:
      'If you Europe in your mind, MCAST is the destination to be and have schengen visa',
    universityWebsite: 'https://www.mcast.edu.mt/',
    imageName: mcast,
    variant: 'hover',
    tagLine: 'if Europe is on your mind MCAST is a ray of Shine',
    route: 'MCAST',
    url: 'https://www.antaifintechglobal.com/mcast/',
    target: '_blank'
  },
  {
    id: '2',
    universityName: 'Manipal University, Dubai',
    backTile:
      'UK degree with Indian Diploma, 2 Top universities Manipal and ARU have come together',
    universityWebsite: 'https://www.manipaldubai.com/',
    imageName: manipalUniversity,
    variant: 'hover',
    tagLine: 'Dubai Diploma with UK degree a Unique world-class MBA',
    route: 'Manipal',
    url: 'https://www.antaifintechglobal.com/manipal-university/',
    target: '_blank'
  },
  {
    id: '3',
    universityName: 'University of Bolton',
    backTile:
      'Migrate to UK with most affordable and prestigious UK degree by Bolton University',
    universityWebsite: 'https://www.bolton.ac.uk/',
    imageName: bolton,
    variant: 'hover',
    tagLine: 'Most prestigious UK degree with 2 Years work visas in the UK',
    route: 'Universityob',
    url: 'https://www.antaifintechglobal.com/university-of-bolton/',
    target: '_blank'
  },
  {
    id: '4',
    universityName: 'Anglia Ruskin University',
    backTile:
      'One of the only two Universities in Cambridge, study at ARU chelmsford campus',
    universityWebsite: 'https://aru.ac.uk/',
    imageName: anglia,
    variant: 'hover',
    tagLine: 'A University from Cambridge making local go global',
    route: 'Anglia',
    url: 'https://www.antaifintechglobal.com/anglia-ruskin-university/',
    target: '_blank'
  },
  {
    id: '5',
    universityName: 'Omnix International ',
    backTile:
      'Most popular and powerful Bim short courses and internships come from OMNIX international',
    universityWebsite: null,
    imageName: omnix,
    variant: 'hover',
    tagLine:
      'Internships, Certifications for AutoCAD- Architectures, Civil Engineers and Mechanical Engineers',
    route: 'Omnix',
    url: null,
    target: ''
  },
  {
    id: '6',
    universityName: 'Faculty Development Program',
    backTile:
      'One of the most promising internationally recognized Faculty development program delivered by Faculties ',
    universityWebsite: null,
    imageName: fdp,
    variant: 'hover',
    tagLine:
      'Faculty Development Program to make you an International Teacher, Globally',
    route: 'fdp',
    url: null,
    target: ''
  },
  {
    id: '7',
    universityName: 'British Council ',
    backTile:
      'Take IELTS or APTIS, visit our page and get to know more about these quick tests',
    universityWebsite: 'https://www.britishcouncil.ae/en',
    imageName: britishCouncil,
    variant: 'hover',
    tagLine:
      'Most Unique programs from British council, exempting IELTS at Universities',
    route: 'British',
    url: null,
    target: ''
  },
  {
    id: '8',
    universityName: 'India - VSCC ',
    backTile:
      'An exclusive offering to students from North India, in association with VSCC',
    universityWebsite: 'www.drvishalsaxenacommerceclasses.com',
    imageName: vscc,
    variant: 'hover',
    tagLine: 'Unique Accounting and Finance blend of Fast Track UK MBA',
    route: 'Vishalscc',
    url: null,
    target: ''
  },
]
